module.exports = __webpack_public_path__ + "static/media/s_5.26ae6446.mp3";